import React, { useEffect, useMemo, useReducer, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { enumUtil } from "../../utils/Enum";
import { ServerRequestProtected } from "../../utils/ServerDataRequest";
import { TabActionPatient } from "../../actions/PatientActions";
import 'react-data-grid/lib/styles.css';
import Loader from "../shared/Loader/Loader";
import { useSelector } from "react-redux";
import { Alphbets } from "../../utils/Constants";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css'; // theme css file
import Table from "../Setup/Shared/Table";
import GridColumnHeader from "../Setup/Shared/GridColumnHeader"
import { PatientRecordAction } from "../../actions/PatientActions";
import { SelectColumn } from "react-data-grid"
import SearchHeader from "../Setup/Shared/SearchHeader";
import OpenQuickPopup from "../shared/OpenQuickPopup/OpenQuickPopup";
import CalendaRangeInput from "../General/CalendarRangeInput";
import handleCopyText from "../shared/CopyData";
import { FindFirstChild } from "../../utils/FindMenuOption";
import SuperSearchMultipleClient from "../shared/SuperSearch/MultipleSelection/SuperSearchMultipleClient";
import MarkNewAttendance from "./PatientAttendanceDetails/MarkNewAttendance";
import AddNewAuthorization from "./PatientDetails/Insurrance/Authorization/AddNewAuthorization";
import isNull from "../../utils/NullChecking";
import { startOfWeek, endOfWeek, addDays, format, eachDayOfInterval } from "date-fns";
import moment from "moment";
import CustomUseRef from "../shared/DropDown/CustomUseRef";
import PatientAttendanceNotes from "./PatientAttendanceDetails/PatientAttendanceNotes";
import NotificationHandler from "../../utils/NotificationHandler";
import AddNewShift from "../Setup/Account/Shift/AddNewShift";
import ReactDataGrid from 'react-data-grid';
import Pagination from "../shared/Pagination/Pagination";
import { GeneralDropDowns } from "../../actions/GeneralPatientActions";

const PatientAttendance = (props) => {
    const { Settings } = { ...props }
    const isEditAllowedPatAtt = FindFirstChild('Patient', 'Patient Attendance')?.IsAdd;
    const IsDeleteAllowedPatAtt = FindFirstChild('Patient', 'Patient Attendance')?.IsDeleted;


    let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    PateintIDR = PateintIDR?.data?.id
    let nameIDR = useSelector((state) =>
        state[`Open_Patient_Tab`].find((pt) => pt.active === true)
    );
    nameIDR = nameIDR?.data?.id;
    let isEditAllowed = FindFirstChild('Patient', 'Patients')?.ISView
    let currentDate = moment().format('MM/DD/YYYY');
    let currentDateObj = new Date();

    // Get the current date week

    const start = startOfWeek(currentDateObj, { weekStartsOn: 0 }); // By default, week starts on Sunday (0)
    const end = endOfWeek(currentDateObj, { weekStartsOn: 0 }); // End of the week is Saturday (6)
    const formateStart = format(start, 'MM/dd/yyyy');
    const formateEnd = format(end, 'MM/dd/yyyy');


    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    let PatientShiftsDD = DropDowns?.Shifts;
    const API_URL_PATIENT = enumUtil.controller.PATIENT;
    const API_URL_Agency = enumUtil.controller.AgencyPatient;
    const API_URL = enumUtil.controller.General;
    let dispatch = useDispatch();
    const [filterShow, setFilterShow] = useState(false);
    let DropdownData = useSelector(state => state.GeneralDropDownsReducer)
    const isHomeCareCheck = DropdownData.IsHomeCare
    const [patientData, setPatientData] = useState([]);
    const [DefaultPatientData, setDefaultPatientData] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [popup, setPopup] = useState(<></>);
    const [IsFilterApplied, setIsFilterApplied] = useState(false)
    const [copiedText, setCopiedText] = useState({});
    const [currentWeek, setCurrentWeek] = useState(`${formateStart + '-' + formateEnd}`);
    const [reloadPatientGrid, setReloadPatientGrid] = useState(false);
    const [reloadCalendarReload, setReloadCalendarReload] = useState(false);
    const [totalCounts, setTotalCounts] = useState(0)
    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })

    //insurance List
    let InsuranceList_Modal = [{
        PatientInsuranceID: "",
        CoveragePriority: "",
        InsuranceName: "",
    }]

    const AuthStatusDD = [

        { color: "Paid-bg", display: 'Active', value: 'Active' },
        { color: "Batch-Acknowledged-Error-bg", display: 'Expiring', value: 'Expiring' },
        { color: "RejectedCH-bg", display: 'Expired', value: 'Expired' },

    ]

    const Search_Date_Param = {
        "DateFrom": currentDate,
        "DateTo": currentDate,
    }

    ///Search///
    const Search_Data = {
        // "SearchLetter": "",
        "SearchCeriteria": "",
        "InsuranceID": "-1",
        // "LocationID": "-1",
        // "ProviderID": "-1",
        // "CoordinatorID": "",
        "Shift": '-1',
        "Status": "-1",
        "DateFrom": formateStart,
        "DateTo": formateEnd,
    }
    const searchButton = {
        AddNew: false,
        Excel: true,
        PDF: false,
        Delete: false,
        Filter: false,
        View: false  // set true if want to display cards as well
    }

    const Week_Header_Modal = {
        Sunday: '',
        Monday: '',
        Tuesday: '',
        Wednesday: '',
        Thursday: '',
        Friday: '',
        Saturday: '',
    }

    const API_URL_GENERAL = enumUtil.controller.General;
    const [searchDateParam, setSearchDateParam] = useState(Search_Date_Param);
    const [searchParam, setSearchParam] = useState(Search_Data);
    const [searchValue, setSearchValue] = useState('');
    const [openTab, setOpenTab] = useState('');
    const [searchLoad, setSearchLoad] = useState(false);
    const [selectedInsurance, setSelectedInsurance] = useState('');
    const [selectCoordinator, setselectCoordinator] = useState('');
    const [selectprovider, setselectprovider] = useState('');
    const [selectLocation, setselectLocation] = useState('');
    const [statusDefault, setStatusDefault] = useState([]);
    const [clear, setClear] = useState(false);
    const [reloadSuperSearch, setReloadSuperSearch] = useState(false);
    const [AttendanceRecord, setAttendaceRecord] = useState(null);
    const [patientID, setPatientID] = useState(null);
    const [weeklyHeaders, setWeeklyHeaders] = useState([]);
    const [selectedRows, setSelectedRows] = useState(new Set());
    const [selectedPatientIDs, setSelectedPatientIDs] = useState("");
    const [PatientDuplicateRecord, setPatientDuplicateRecord] = useState([]);
    const [SelectedRecordsArray, setSelectedRecordsArray] = useState([])
    const [AttendanceType, setAttendnaceType] = useState("")
    const [IsOpenShift, setIsOpenShift] = useState(false);
    const [reloadSuperSearchShift, setReloadSuperSearchShift] = useState(false);
    ////// Patient Attendance ////////////////

    const [IsOpenMarkAttendane, setIsOpenMarkAttendance] = useState(false);
    const [Attendance, setAttendance] = useState(true);
    const [totalcountSummary, setTotalCountSummary] = useState({});
    const [AttendanceRecordID, setAttendanceRecordID] = useState(null);
    const [IsOpenAuthorization, setIsOpenAuthorization] = useState(false);
    const [AuthorizationID, setAuthorizationID] = useState(0);
    const [PatientInsuranceID, setPatientInsuranceID] = useState(0);
    const [InsuranceListModal, setInsuranceListModal] = useState([InsuranceList_Modal]);
    const [showBillingNote, setShowBillingNote] = useState(false);
    const [selectRow, setSelectedRow] = useState();
    const [headers, setHeadersArray] = useState([]);
    //For Pagination
    const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
    const [PageNo, setPageNo] = useState(1);
    const [TotalPages, setTotalPages] = useState();
    const handlePageClick = (page) => { setPageNo(page); }
    const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    const handleFingByCreteria = (e) => {
        setPerPage(e.target.value)
        setPageNo(1)
    }
    ///////////
    const AddNewPatient = () => {
        let dataObj = {
            key: 2,
            name: "Patient",
            active: true,
            data: {
                name: "New Patient",
                id: -1,
                time: new Date()
            },
        };
        props.TabActionPatient(dataObj);
    }

    const handleInsurranceDetails = async () => {
        if (PateintIDR != -1) {
            setIsLoading(true)
            ServerRequestProtected(API_URL_PATIENT + "/FindPatientInsuranceDetails", 'post', {
                "ID": PateintIDR,
                "TableName": enumUtil.enumAPITableName.PatientInsurance
            }).then(async (response) => {
                setInsuranceListModal(response)
            })
                .catch((error) => {
                    setIsLoading(false)
                })
        }
    }

    const LoadData = (searchParam) => {

        setIsLoading(true);
        setPatientData([]);
        setDefaultPatientData([]);
        ServerRequestProtected(API_URL_Agency + "/GetPatientAttendance", 'post', {
            "TableName": enumUtil.enumAPITableName.PATIENTATTENDANCE,
            "SearchCriteria": searchParam,
            "PerPage": PerPage,
            "PageNo": PageNo,
        })
            .then((response) => {
                setIsLoading(false);
                setPatientData(response?.Rows);
                setDefaultPatientData(response?.Rows);
                setTotalPages(response?.Counts?.NumOfPages);
                setTotalCounts(response.Rows.length)
                handleGridHeader({ defaultData: response?.Rows });

                setTotalCountSummary({ ...response?.Counts });
                // let headers = GenerateHeaders(searchParam?.DateFrom);
                let headers = generateHeaders(searchParam?.DateFrom, searchParam?.DateTo);

                // let PatientData = [];
                // PatientData = response.Rows.map((item, index) => {
                //     let newlist = { ID: item.ID, name: item.FirstName, FullName: item.FirstName + ', ' + item.LastName + ', ' + item.AccountNumber }
                //     return newlist;

                // })
            }).catch((error) => {
                // console.log("ERROR", error)
                // NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
                setPatientData([]);
                setDefaultPatientData([]);
                setTotalCounts(0)
                // setReloadPatientGrid(!reloadPatientGrid);
                setIsLoading(false);
            })
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            setSearchParam({ ...searchParam, SearchCeriteria: e.target.value })
            SearchByParam(searchParam)
        }
    }
    const SearchByParam = () => {
        if (!isNull(searchParam)) {

            let dateInRange = checkDateRange(searchParam?.DateFrom, searchParam?.DateTo);

            if (dateInRange) {
                setPageNo(1);
                LoadData(searchParam);
            }

        } else {
            LoadData()
        }
    }
    const handleApply = () => {
        setIsFilterApplied(true)
        if (!isNull(searchParam)) {
            setPageNo('1')
            LoadData(searchParam)
        } else {
            LoadData()
        }
    }

    const handleSelectData = (data) => {
        setPerPage(data.value)
        setPageNo(1)
    }
    useEffect(() => {
        if (isEditAllowed) {
            setIsLoading(true);
            setPatientData([])
            LoadData(searchParam);
        }
    }, [PerPage, PageNo, searchLoad])
    //seacrhParam
    // useEffect(() => { props.setRecordsNum(patientData.length) }, [patientData])
    let GenDD = useSelector(state => state.GeneralDropDownsReducer)

    const OpenPatient = (data) => {
        let obj = {
            key: 2,
            name: "Patient",
            active: true,
            data: {
                id: data.PatientID,
                name: data.FirstName,
                FullName: data.LastName + " " + data.FirstName,
                time: new Date(),
            },
        };
        props.TabActionPatient(obj);
        setTimeout(() => {
            AddEmptyValuesForPatDiscard(data);
        }, 0);
    }
    const AddEmptyValuesForPatDiscard = (data) => {
        dispatch(GeneralDropDowns({
            ...GenDD, DisCardActiveIds: {
                ...GenDD?.DisCardActiveIds,
                Patient: [...GenDD?.DisCardActiveIds.Patient, {
                    isDemographicsOpened: false,
                    isDemographicsUpdated: false,
                    isInsuranceOpened: false,
                    isInsuranceUpdated: false,
                    PatientID: data.PatientID,
                }]
            }
        }))
    }
    const OpenPatientDetails = (data, type) => {

        let obj = {
            key: 2,
            name: "Patient",
            active: true,
            data: {
                id: data.PatientID,
                name: data.FirstName,
                time: new Date(),
                type: type,
            },
        };
        props.TabActionPatient(obj);
    }
    /////// viewAllClaims ///////
    const handleViewAllClaim = (PatID, PatName) => {
        let dataObj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                name: "All Claims",
                id: 0,
                time: new Date(),
                visitType: {
                    type: 'ClaimSearch',
                    PatientID: PatID,
                    PatientName: PatName,
                },
            },
        };
        setOpenTab(dataObj)
    }
    const OpenQuickPopupMemoized = ({ row, setPopup, name }) => {
        const memoizedPopup = useMemo(() => {
            if (name === 'Insurance') {
                return (
                    <OpenQuickPopup ID={row.InsuranceID} name={row.InsuranceName} setPopup={setPopup} popupName={name} />);
            }
        }, [row, name]);

        return memoizedPopup;
    };
    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;

        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }

    const clearFilter = () => {
        setIsFilterApplied(false)
        setReloadSuperSearch(!reloadSuperSearch)
        setSearchParam({
            SearchCeriteria: "", InsuranceID: "-1",
            DateFrom: formateStart, DateTo: formateEnd, Status: "-1", Shift: "-1",
        })
        setReloadCalendarReload(!reloadCalendarReload);
        setSearchDateParam(() => ({ DateFrom: formateStart, DateTo: formateEnd }));
        setSelectedInsurance('');
        setselectCoordinator('');
        setselectprovider('');
        setselectLocation('');
        setFilterShow(false)
        setClear(true);
        // GenerateHeaders(currentWeek);
    }
    const rowClass = () => { return "row-bg" }
    const [is, setIs] = useState(false);

    const onRowSelection = (listOfIds) => {

        const seen = new Map();
        const duplicates = [];
        let newList = []
        const tempIdsArr = []


        listOfIds.forEach((id) => {
            patientData.forEach((el) => {
                if (el.id === id) {
                    newList.push(el);
                    tempIdsArr.push(el?.PatientID);

                    if (seen.has(el.PatientID)) {
                        duplicates.push({
                            PatientID: el?.PatientID,
                            PatientName: el?.PatientName,
                        });
                    } else {
                        seen.set(el?.PatientID, true);
                    }
                }

            })
        })

        setSelectedRows(listOfIds);
        setSelectedRecordsArray(newList);
        // const commaSeparatedDuplicates = duplicates.join(', ');
        setPatientDuplicateRecord(duplicates);
        const commaSeparatedIds = tempIdsArr.join(', ');
        setSelectedPatientIDs(commaSeparatedIds);
    }

    const rowKeyGetter = (row) => {

        return row?.PatientID;

    }
    // const columnsAll = [
    //     { key: 'Account', name: 'Account #' },
    //     { key: 'Name', name: 'Name' },
    //     { key: 'DOB', name: 'Date of Birth' },
    //     { key: 'Insured', name: 'Insured' },
    //     { key: 'BalanceDuePat', name: 'Balance due Pat.' },
    //     { key: 'AccountPhone', name: 'Account Phone' },
    // ]

    // const rowsAll = [
    //     { "Account": "3129831298", "Name": "Alex", "DOB": "04/19/2017", "Insured": "", "BalanceDuePat": "1234", "AccountPhone": "1234567890" },
    // ]

    const summaryRow = {
        Mon: totalcountSummary?.MondayTotal,
        Tue: totalcountSummary?.TuesdayTotal,
        Wed: totalcountSummary?.WednesdayTotal,
        Thu: totalcountSummary?.ThursdayTotal,
        Fri: totalcountSummary?.FridayTotal,
        Sat: totalcountSummary?.SaturdayTotal,
        Sun: totalcountSummary?.SundayTotal,
        Present: totalcountSummary?.TotalPresent,
        Absent: totalcountSummary?.TotalAbsent,
    };

    const columns = [
        // {
        //     ...SelectColumn,
        //     width:150,
        //     renderCell: ({row}) => {
        //         console.log("ROW_SELCTCOLS",row, SelectColumn )
        //     }
        // },
        {
            ...SelectColumn,
        },
        {
            // key: 'PatientName',
            name: "Patient Detail",
            // width: 155,
            children: [
                // SelectColumn,
                {
                    key: 'PatientName',

                    width: 118,
                    name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                        iconName={'icon-location'} headerName={'Patient'} sortIcon={true} type={'string'} colKey={'PatientName'} data={patientData} setData={setPatientData} />),

                    renderCell: ({ row }) => {
                        return (
                            <p className="text fs-12 za-blue-clr cursor-pointer" onClick={() => OpenPatient(row)}>{row?.PatientName}</p>
                        );
                    }
                },

                {
                    key: 'DOB',

                    width: 85,
                    name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                        iconName={'icon-location'} headerName={'DOB'} sortIcon={true} type={'date'} colKey={'DOB'} data={patientData} setData={setPatientData} />),

                },

                {
                    key: 'MedicaidNo',
                    width: 100,
                    name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                        iconName={'icon-location'} headerName={'Medicaid #'} sortIcon={true} type={'string'} colKey={'MedicaidNo'} data={patientData} setData={setPatientData} />),
                    renderCell: ({ row }) => {
                        return (
                            <>
                                <div className="align-items-center copy_icon pri_ins copy_icon_hover d-flex gap-1 justify-content-between w-100">
                                    <div className="copy_icon validation_message" title={row?.MedicaidNo}>
                                        {row?.MedicaidNo}
                                    </div>
                                    {row?.MedicaidNo && (
                                        <div className="icon_copy">
                                            <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row?.PatientID, row?.MedicaidNo)} ></i>
                                            <p className="tool_tip xsm_text text-light">Copy</p>
                                        </div>
                                    )}
                                    {copiedText[`${row?.PatientID}-${row?.MedicaidNo}`] ? (
                                        <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </>
                        )
                    }
                },

                {
                    key: 'InsuranceName',
                    width: 109,
                    name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                        iconName={'icon-location'} headerName={'Pri Insurance'} sortIcon={true} type={'string'} colKey={'InsuranceName'} data={patientData} setData={setPatientData} />),
                    renderCell: ({ row }) => {
                        return (
                            <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                                <div className="copy_icon validation_message">
                                    <OpenQuickPopupMemoized row={row} setPopup={setPopup} name={'Insurance'} />
                                    {/* <OpenQuickPopup ID={row.PrimaryInsuranceID} name={row.PrimaryInsurance} setPopup={setPopup} popupName={'Insurance'} /> */}
                                </div>
                                {row?.InsuranceName && (
                                    <div className="icon_copy">
                                        <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row?.PatientID, row?.InsuranceName)} ></i>
                                        <p className="tool_tip xsm_text text-light">Copy</p>
                                    </div>
                                )}
                                {copiedText[`${row?.PatientID}-${row?.InsuranceName}`] ? (
                                    <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p>
                                ) : (
                                    <></>
                                )}
                            </div>
                        )
                    }
                },

                {
                    key: 'SubscriberID',
                    width: 120,
                    name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                        iconName={'icon-location'} headerName={'Member ID'} sortIcon={true} type={'string'} colKey={'SubscriberID'} data={patientData} setData={setPatientData} />),
                    renderCell: ({ row }) => {
                        return (
                            <>
                                <div className="align-items-center copy_icon pri_ins copy_icon_hover d-flex gap-1 justify-content-between w-100">
                                    <div className="copy_icon validation_message" title={row?.SubscriberID}>
                                        {row?.SubscriberID}
                                    </div>
                                    {row?.SubscriberID && (
                                        <div className="icon_copy">
                                            <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row?.PatientID, row?.SubscriberID)} ></i>
                                            <p className="tool_tip xsm_text text-light">Copy</p>
                                        </div>
                                    )}
                                    {copiedText[`${row?.PatientID}-${row?.SubscriberID}`] ? (
                                        <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </>
                        )
                    }
                },

                {
                    key: 'AuthorizationNumber',
                    name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                        iconName={'icon-location'} headerName={'Auth #'} sortIcon={true} type={'string'} colKey={'AuthorizationNumber'} data={patientData} setData={setPatientData} />),

                    width: 92,

                    renderCell: ({ row }) => {
                        return (
                            <>
                                <div className="align-items-center copy_icon pri_ins copy_icon_hover d-flex gap-1 justify-content-between w-100">
                                    {/* <div className="copy_icon validation_message" title={row?.authNumber}> */}
                                    <div className={`slim_link_hover ${row.AuthorizationStatus === "Expiring" ? "d-flex justify-content-center orange-bg text-white w-100" : row?.AuthorizationStatus === "Expired" ? "d-flex justify-content-center p-0 red-bg-box text-white w-100" : ""}`}
                                        onClick={() => { handleOpenAuthorization(row) }}>
                                        {row?.AuthorizationNumber}
                                    </div>
                                    {/* </div> */}
                                    {/* {row?.authNumber && (
                                        <div className="icon_copy">
                                            <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row?.PatientID, row?.authNumber)} ></i>
                                            <p className="tool_tip xsm_text text-light">Copy</p>
                                        </div>
                                    )}
                                    {copiedText[`${row?.PatientID}-${row?.authNumber}`] ? (
                                        <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p>
                                    ) : (
                                        <></>
                                    )} */}
                                </div>
                            </>
                        )
                    }
                },

                {
                    key: 'StartDate',
                    name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                        iconName={'icon-location'} headerName={'Start Date'} sortIcon={true} type={'date'} colKey={'StartDate'} data={patientData} setData={setPatientData} />),

                    width: 90,
                    renderCell: ({ row }) => {
                        return (
                            <div className={`${row.AuthorizationStatus === "Expiring" ? "d-flex justify-content-center orange-bg text-white w-100" : row?.AuthorizationStatus === "Expired" ? "d-flex justify-content-center p-0 red-bg-box text-white w-100" : ""}`}>
                                {row?.StartDate}
                            </div>
                        )
                    },
                },

                {
                    key: 'EndDate',
                    name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                        iconName={'icon-location'} headerName={'End Date'} sortIcon={true} type={'date'} colKey={'EndDate'} data={patientData} setData={setPatientData} />),

                    width: 83,
                    renderCell: ({ row }) => {
                        return (<div className={`${row.AuthorizationStatus === "Expiring" ? "d-flex justify-content-center orange-bg text-white w-100" : row?.AuthorizationStatus === "Expired" ? "d-flex justify-content-center p-0 red-bg-box text-white w-100" : ""}`}>
                            {row?.EndDate}
                        </div>)
                    },
                },

                {
                    key: 'AuthorizationStatus',
                    name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                        iconName={'icon-location'} headerName={'Status'} sortIcon={true} type={'string'} colKey={'AuthorizationStatus'} data={patientData} setData={setPatientData} />),
                    width: 68,
                    renderCell: ({ row }) => {
                        return (
                            <>
                                {row?.AuthorizationStatus ?
                                    <p className={`text fs-12 ar-status-clm pill
                                     ${row.AuthorizationStatus === "Expiring" ? "Not-confirmed" : row?.AuthorizationStatus === "Expired" ? "Partialdenied" : "Paid"}`}>
                                        {row?.AuthorizationStatus}
                                    </p> : <></>}

                            </>
                        );
                    }
                },
            ],
        },
        {
            // key: 'sun',
            name: "Sun",
            width: "50px",
            children: [
                {
                    key: 'Day',
                    resizeable: true,
                    name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                        iconName={'icon-location'} headerName={weeklyHeaders?.['Sun']?.date} sortIcon={false} type={'string'} colKey={'Day'} data={patientData} setData={setPatientData} />),

                    renderCell: ({ row }) => {

                        let sundayRecord = {};
                        if (row?.Children && row?.Children?.length > 0) {
                            sundayRecord = row?.Children?.filter((item) => item?.Day === 'Sunday')[0];
                        }

                        return (
                            <div className="align-items-center d-flex justify-content-center position-relative w-100 za-denied-status">

                                {(sundayRecord?.Attendance === 'P' || sundayRecord?.Attendance === 'A')
                                    ?
                                    <div className={(sundayRecord?.IsScheduleCreated === '1' || sundayRecord?.IsAllowedDays === '1') ? "days-scheduled" : ""}>
                                        <p className={`heading fs-12 za-table-status ${sundayRecord?.Attendance === 'P' ? 'green-bg' : sundayRecord?.Attendance === 'A' ? 'red-bg' : ''}  `}>{sundayRecord?.Attendance}</p>
                                        <div className="app_tooltip right position-absolute cancel-attendance" onClick={() => handleClearAttendance(sundayRecord)}>
                                            <i className="icon-Icon-metro-cross fs-8" ></i>
                                            <p class="tool_tip xsm_text text-light text-nowrap">Cancel Attendance</p>
                                        </div>
                                        {(sundayRecord?.Attendance === 'P' && isNull(sundayRecord?.CheckOut)) ? <div className="istrick fs-20 position-absolute">*</div> : <></>}
                                        <div className="xsm_text text-light tool_tip attendance_card position-absolute">
                                            <p className="heading fs-10 text-center pt-2">{sundayRecord?.AttendanceDate}</p>
                                            <div className="br-bottom-1 br-light my-1"></div>
                                            {sundayRecord?.Attendance === 'P' ?
                                                <>
                                                    <div className="d-flex justify-content-between px-2 pb-1-5">

                                                        <div className="d-flex align-items-center gap-1">
                                                            <div className="za-round"></div>
                                                            <p className="text fs-10 font-m">Check-In</p>
                                                        </div>

                                                        <p className="text fs-10">{sundayRecord?.CheckIn}</p>


                                                    </div>
                                                    <div className="d-flex justify-content-between px-2 pb-1-5">

                                                        <div className="d-flex align-items-center gap-1">
                                                            <div className="za-round"></div>
                                                            <p className="text fs-10 font-m">Check-Out</p>
                                                        </div>

                                                        {!isNull(sundayRecord?.CheckOut) ?

                                                            <p className="text fs-10">{sundayRecord?.CheckOut}</p>
                                                            :
                                                            <div className="icon-plus d-flex justify-content-center align-items-center" onClick={() => handleOpenMarkAttendance(sundayRecord)}>
                                                                <i className=" icon-dash-plus fs-19"></i>
                                                            </div>

                                                        }
                                                    </div>
                                                </> :
                                                <>
                                                    {/* <div className="d-flex justify-content-between px-2 pb-1-5">

                                                        <div className="d-flex align-items-center gap-1">
                                                            <div className="za-round"></div>
                                                            <p className="text fs-10 font-m">Mark Present</p>
                                                        </div>

                                                        <div className="icon-plus d-flex justify-content-center align-items-center" onClick={() => handleOpenMarkAttendance(sundayRecord)}>
                                                            <i className=" icon-dash-plus fs-19"></i>
                                                        </div>
                                                    </div> */}
                                                    <p class="fs-10 text px-1 multi-line-truncate text-wrap overflow-hidden">{sundayRecord?.Reason} </p>
                                                </>
                                            }
                                        </div>
                                    </div>
                                    : sundayRecord?.isBlocked === '1' ? <div className="days-block"></div> :
                                        <div className={(sundayRecord?.IsScheduleCreated === '1' || sundayRecord?.IsAllowedDays === '1') ? "days-scheduled" : ""}>
                                            <div className="ar_mark-attendance-hov position-relative">
                                                <button className="btn btn-plusicon d-flex justify-content-center align-items-center">
                                                    <i className=" icon-dash-plus fs-19" /* onClick={() => handleOpenMarkAttendance(sundayRecord)} */></i>
                                                </button>
                                                <div className="content-box">
                                                    <div className="d-flex align-items-center justify-content-between px-1-5 br-bottom-1 za_br_light pb-1-5">
                                                        <p className="heading fs-10 lh-10">Mark Attendance</p>
                                                        <div className="icon-Icon-metro-cross fs-8"></div>
                                                    </div>
                                                    <div className="pt-1-5 px-1-5">
                                                        <div className="d-flex align-items-center justify-content-between mb-2 selection-hover">
                                                            <p className={isEditAllowedPatAtt ? "text lh-18 ar-dot cursor-pointer" : "text lh-18 ar-dot cursor-pointer disabled"}
                                                                onClick={() => handleSaveAttendnace(sundayRecord, true)}>Present</p>
                                                            <i className="icon-time-clock fs-12" onClick={() => handleOpenMarkAttendance(sundayRecord, null, null, true)}></i>
                                                        </div>
                                                        <div className="cursor-pointer selection-hover">
                                                            <p className={isEditAllowedPatAtt ? "text lh-18 ar-dot absent" : "text lh-18 ar-dot absent disabled"} onClick={() => handleOpenMarkAttendance(sundayRecord, null, null, false)}>Absent</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                            </div >
                        );
                    },
                    renderSummaryCell() {
                        return summaryRow?.Sun;
                    }
                }
            ],

        },
        {
            // key: 'mon', 
            name: "Mon",
            width: "50px",
            children: [
                {
                    key: 'Monday',
                    resizeable: true,
                    name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                        iconName={'icon-location'} headerName={weeklyHeaders?.['Mon']?.date} sortIcon={false} type={'string'} colKey={'Day'} data={patientData} setData={setPatientData} />),

                    renderCell: ({ row }) => {

                        let mondayRecord = {};
                        if (row?.Children && row?.Children?.length > 0) {
                            mondayRecord = row?.Children?.filter((item) => item?.Day === 'Monday')[0];
                        }

                        return (
                            <div className="align-items-center d-flex justify-content-center position-relative w-100 za-denied-status">
                                {(mondayRecord?.Attendance === 'P' || mondayRecord?.Attendance === 'A') ?
                                    <div className={(mondayRecord?.IsScheduleCreated === '1' || mondayRecord?.IsAllowedDays === '1') ? "days-scheduled" : ""}>
                                        <p className={`heading fs-12 za-table-status ${mondayRecord?.Attendance === "P" ? 'green-bg' : mondayRecord?.Attendance === "A" ? 'red-bg' : ''} `}>{mondayRecord?.Attendance}</p>
                                        <div className="app_tooltip right position-absolute cancel-attendance" onClick={() => handleClearAttendance(mondayRecord)}>
                                            <i className="icon-Icon-metro-cross fs-8" ></i>
                                            <p class="tool_tip xsm_text text-light text-nowrap">Cancel Attendance</p>
                                        </div>
                                        {(mondayRecord?.Attendance === 'P' && isNull(mondayRecord?.CheckOut)) ? <div className="istrick fs-20 position-absolute">*</div> : <></>}
                                        <div className="xsm_text text-light tool_tip attendance_card position-absolute">
                                            <p className="heading fs-10 text-center pt-2">{mondayRecord?.AttendanceDate}</p>
                                            <div className="br-bottom-1 br-light my-1"></div>
                                            {mondayRecord?.Attendance === 'P' ?
                                                <>
                                                    <div className="d-flex justify-content-between px-2 pb-1-5">

                                                        <div className="d-flex align-items-center gap-1">
                                                            <div className="za-round"></div>
                                                            <p className="text fs-10 font-m">Check-In</p>
                                                        </div>
                                                        <div className="text fs-10">{mondayRecord?.CheckIn}</div>
                                                    </div>
                                                    <div className="d-flex justify-content-between px-2 pb-1-5">
                                                        <div className="d-flex align-items-center gap-1">
                                                            <div className="za-round"></div>
                                                            <p className="text fs-10 font-m">Check-Out</p>
                                                        </div>

                                                        {!isNull(mondayRecord?.CheckOut) ?
                                                            <p className="text fs-10">{mondayRecord?.CheckOut}</p>
                                                            :
                                                            <div className="icon-plus d-flex justify-content-center align-items-center" onClick={() => handleOpenMarkAttendance(mondayRecord)}>
                                                                <i className=" icon-dash-plus fs-19"></i>
                                                            </div>
                                                        }
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    {/* <div className="d-flex justify-content-between px-2 pb-1-5">

                                                        <div className="d-flex align-items-center gap-1">
                                                            <div className="za-round"></div>
                                                            <p className="text fs-10 font-m">Mark Present</p>
                                                        </div>

                                                        <div className="icon-plus d-flex justify-content-center align-items-center" onClick={() => handleOpenMarkAttendance(mondayRecord)}>
                                                            <i className=" icon-dash-plus fs-19"></i>
                                                        </div>

                                                    </div> */}
                                                    <p class="fs-10 text px-1 multi-line-truncate text-wrap overflow-hidden">{mondayRecord?.Reason} </p>
                                                </>
                                            }

                                        </div>
                                    </div>
                                    : mondayRecord?.isBlocked === '1' ? <div className="days-block"></div> :
                                        <div className={(mondayRecord?.IsScheduleCreated === '1' || mondayRecord?.IsAllowedDays === '1') ? "days-scheduled" : ""}>
                                            <div className="ar_mark-attendance-hov position-relative">
                                                <button className="btn btn-plusicon d-flex justify-content-center align-items-center">
                                                    <i className=" icon-dash-plus fs-19" /* onClick={() => handleOpenMarkAttendance(mondayRecord)} */></i>
                                                </button>
                                                <div className="content-box">
                                                    <div className="d-flex align-items-center justify-content-between px-1-5 br-bottom-1 za_br_light pb-1-5">
                                                        <p className="heading fs-10 lh-10">Mark Attendance</p>
                                                        <div className="icon-Icon-metro-cross fs-8"></div>
                                                    </div>
                                                    <div className="pt-1-5 px-1-5">
                                                        <div className="d-flex align-items-center justify-content-between mb-2 selection-hover">
                                                            <p className={isEditAllowedPatAtt ? "text lh-18 ar-dot cursor-pointer " : "text lh-18 ar-dot cursor-pointer disabled"} onClick={() => handleSaveAttendnace(mondayRecord, true)}>Present</p>
                                                            <i className="icon-time-clock fs-12" onClick={() => handleOpenMarkAttendance(mondayRecord, null, null, true)}></i>
                                                        </div>
                                                        <div className="cursor-pointer selection-hover">
                                                            <p className={isEditAllowedPatAtt ? "text lh-18 ar-dot absent" : "text lh-18 ar-dot absent disabled"} onClick={() => handleOpenMarkAttendance(mondayRecord, null, null, false)}>Absent</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                }
                            </div>
                        );
                    },
                    renderSummaryCell() {
                        return summaryRow?.Mon;
                    }
                }],

        },
        {
            // key: 'tue',
            name: "Tue",

            width: "50px",
            children: [{
                key: 'Tuesday',
                resizeable: true,
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-location'} headerName={weeklyHeaders?.['Tue']?.date} sortIcon={false} type={'string'} colKey={'Day'} data={patientData} setData={setPatientData} />),

                renderCell: ({ row }) => {

                    let tuesdayRecord = {};
                    if (row?.Children && row?.Children?.length > 0) {
                        tuesdayRecord = row?.Children?.filter((item) => item?.Day === 'Tuesday')[0];
                    }

                    return (
                        <div className="align-items-center d-flex justify-content-center position-relative w-100 za-denied-status">

                            {(tuesdayRecord?.Attendance === 'P' || tuesdayRecord?.Attendance === 'A') ?
                                <div className={(tuesdayRecord?.IsScheduleCreated === '1' || tuesdayRecord?.IsAllowedDays === '1') ? "days-scheduled" : ""}>
                                    <p className={`heading fs-12 za-table-status ${tuesdayRecord?.Attendance === 'P' ? 'green-bg' : tuesdayRecord?.Attendance === 'A' ? 'red-bg' : ''}  `}>{tuesdayRecord?.Attendance}</p>
                                    <div className="app_tooltip right position-absolute cancel-attendance" onClick={() => handleClearAttendance(tuesdayRecord)}>
                                        <i className="icon-Icon-metro-cross fs-8"></i>
                                        <p class="tool_tip xsm_text text-light text-nowrap">Cancel Attendance</p>
                                    </div>
                                    {(tuesdayRecord?.Attendance === 'P' && isNull(tuesdayRecord?.CheckOut)) ? <div className="istrick fs-20 position-absolute">*</div> : <></>}
                                    <div className="xsm_text text-light tool_tip attendance_card position-absolute">
                                        <p className="heading fs-10 text-center pt-2">{tuesdayRecord?.AttendanceDate}</p>
                                        <div className="br-bottom-1 br-light my-1"></div>
                                        {/* <div className="d-flex justify-content-between px-2 pb-1-5">
                                            <p className="text fs-10 font-m">Mark As Present</p>
                                            <div className="icon-plus d-flex justify-content-center align-items-center" onClick={() => handleOpenMarkAttendance(tuesdayRecord)}>
                                                <i className=" icon-dash-plus fs-19"></i>
                                            </div>
                                        </div> */}
                                        {tuesdayRecord?.Attendance === 'P' ? <>
                                            <div className="d-flex justify-content-between px-2 pb-1-5">

                                                <div className="d-flex align-items-center gap-1">
                                                    <div className="za-round"></div>
                                                    <p className="text fs-10 font-m">Check-In</p>
                                                </div>

                                                <p className="text fs-10">{tuesdayRecord?.CheckIn}</p>


                                            </div>
                                            <div className="d-flex justify-content-between px-2 pb-1-5">

                                                <div className="d-flex align-items-center gap-1">
                                                    <div className="za-round"></div>
                                                    <p className="text fs-10 font-m">Check-Out</p>
                                                </div>

                                                {!isNull(tuesdayRecord?.CheckOut) ?

                                                    <p className="text fs-10">{tuesdayRecord?.CheckOut}</p>
                                                    :
                                                    <div className="icon-plus d-flex justify-content-center align-items-center" onClick={() => handleOpenMarkAttendance(tuesdayRecord)}>
                                                        <i className=" icon-dash-plus fs-19"></i>
                                                    </div>

                                                }
                                            </div>
                                        </> :
                                            <>
                                                {/* <div className="d-flex justify-content-between px-2 pb-1-5">

                                                    <div className="d-flex align-items-center gap-1">
                                                        <div className="za-round"></div>
                                                        <p className="text fs-10 font-m">Mark Present</p>
                                                    </div>

                                                    <div className="icon-plus d-flex justify-content-center align-items-center" onClick={() => handleOpenMarkAttendance(tuesdayRecord)}>
                                                        <i className=" icon-dash-plus fs-19"></i>
                                                    </div>

                                                </div> */}
                                                <p class="fs-10 text px-1 multi-line-truncate text-wrap overflow-hidden">{tuesdayRecord?.Reason} </p>
                                            </>
                                        }

                                    </div>
                                </div>
                                : tuesdayRecord?.isBlocked === '1' ? <div className="days-block"></div> :
                                    <div className={(tuesdayRecord?.IsScheduleCreated === '1' || tuesdayRecord?.IsAllowedDays === '1') ? "days-scheduled" : ""}>
                                        <div className="ar_mark-attendance-hov position-relative">
                                            <button className="btn btn-plusicon d-flex justify-content-center align-items-center">
                                                <i className=" icon-dash-plus fs-19" /* onClick={() => handleOpenMarkAttendance(tuesdayRecord)}*/ ></i>
                                            </button>
                                            <div className="content-box">
                                                <div className="d-flex align-items-center justify-content-between px-1-5 br-bottom-1 za_br_light pb-1-5">
                                                    <p className="heading fs-10 lh-10">Mark Attendance</p>
                                                    <div className="icon-Icon-metro-cross fs-8"></div>
                                                </div>
                                                <div className="pt-1-5 px-1-5">
                                                    <div className="d-flex align-items-center justify-content-between mb-2 selection-hover">
                                                        <p className={isEditAllowedPatAtt ? "text lh-18 ar-dot cursor-pointer" : "text lh-18 ar-dot cursor-pointer disabled"} onClick={() => handleSaveAttendnace(tuesdayRecord, true)}>Present</p>
                                                        <i className="icon-time-clock fs-12" onClick={() => handleOpenMarkAttendance(tuesdayRecord, null, null, true)}></i>
                                                    </div>
                                                    <div className="cursor-pointer selection-hover">
                                                        <p className={isEditAllowedPatAtt ? "text lh-18 ar-dot absent" : "text lh-18 ar-dot absent disabled"} onClick={() => handleOpenMarkAttendance(tuesdayRecord, null, null, false)}>Absent</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                        </div>
                    );
                },
                renderSummaryCell: () => {
                    return <div className="d-flex justify-content-center align-items-center">{summaryRow?.Tue}</div>;
                }
            }],

        },
        {
            // key: 'wed',
            name: "Wed",

            width: "50px",
            children: [
                {
                    key: 'Wednesday',
                    resizeable: true,
                    name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                        iconName={'icon-location'} headerName={weeklyHeaders?.['Wed']?.date} sortIcon={false} type={'string'} colKey={'Day'} data={patientData} setData={setPatientData} />),

                    renderCell: ({ row }) => {

                        let wednesdayRecord = {};
                        if (row?.Children && row?.Children?.length > 0) {
                            wednesdayRecord = row?.Children?.filter((item) => item?.Day === 'Wednesday')[0];
                        }

                        return (
                            <div className="align-items-center d-flex justify-content-center position-relative w-100 za-denied-status">

                                {(wednesdayRecord?.Attendance === 'P' || wednesdayRecord?.Attendance === 'A') ?
                                    <div className={(wednesdayRecord?.IsScheduleCreated === '1' || wednesdayRecord?.IsAllowedDays === '1') ? "days-scheduled" : ""}>
                                        <p className={`heading fs-12 za-table-status ${wednesdayRecord?.Attendance === 'P' ? 'green-bg' : wednesdayRecord?.Attendance === 'A' ? 'red-bg' : ''}  `}>{wednesdayRecord?.Attendance}</p>
                                        <div className="app_tooltip right position-absolute cancel-attendance" onClick={() => handleClearAttendance(wednesdayRecord)}>
                                            <i className="icon-Icon-metro-cross fs-8" ></i>
                                            <p class="tool_tip xsm_text text-light text-nowrap">Cancel Attendance</p>
                                        </div>
                                        {(wednesdayRecord?.Attendance === 'P' && isNull(wednesdayRecord?.CheckOut)) ? <div className="istrick fs-20 position-absolute">*</div> : <></>}
                                        <div className="xsm_text text-light tool_tip attendance_card position-absolute">
                                            <p className="heading fs-10 text-center pt-2">{wednesdayRecord?.AttendanceDate}</p>
                                            <div className="br-bottom-1 br-light my-1"></div>
                                            {wednesdayRecord?.Attendance === 'P' ?
                                                <>
                                                    <div className="d-flex justify-content-between px-2 pb-1-5">

                                                        <div className="d-flex align-items-center gap-1">
                                                            <div className="za-round"></div>
                                                            <p className="text fs-10 font-m">Check-In</p>
                                                        </div>

                                                        <p className="text fs-10">{wednesdayRecord?.CheckIn}</p>


                                                    </div>
                                                    <div className="d-flex justify-content-between px-2 pb-1-5">

                                                        <div className="d-flex align-items-center gap-1">
                                                            <div className="za-round"></div>
                                                            <p className="text fs-10 font-m">Check-Out</p>
                                                        </div>

                                                        {!isNull(wednesdayRecord?.CheckOut) ?

                                                            <p className="text fs-10">{wednesdayRecord?.CheckOut}</p>
                                                            :
                                                            <div className="icon-plus d-flex justify-content-center align-items-center" onClick={() => handleOpenMarkAttendance(wednesdayRecord)}>
                                                                <i className=" icon-dash-plus fs-19"></i>
                                                            </div>

                                                        }
                                                    </div>
                                                </> :
                                                <>
                                                    {/* <div className="d-flex justify-content-between px-2 pb-1-5">

                                                        <div className="d-flex align-items-center gap-1">
                                                            <div className="za-round"></div>
                                                            <p className="text fs-10 font-m">Mark Present</p>
                                                        </div>

                                                        <div className="icon-plus d-flex justify-content-center align-items-center" onClick={() => handleOpenMarkAttendance(wednesdayRecord)}>
                                                            <i className=" icon-dash-plus fs-19"></i>
                                                        </div>

                                                    </div> */}
                                                    <p class="fs-10 text px-1 multi-line-truncate text-wrap overflow-hidden">{wednesdayRecord?.Reason} </p>
                                                </>
                                            }
                                        </div>
                                    </div>
                                    : wednesdayRecord?.isBlocked === '1' ? <div className="days-block"></div> :
                                        <div className={(wednesdayRecord?.IsScheduleCreated === '1' || wednesdayRecord?.IsAllowedDays === '1') ? "days-scheduled" : ""}>
                                            <div className="ar_mark-attendance-hov position-relative">
                                                <button className="btn btn-plusicon d-flex justify-content-center align-items-center">
                                                    <i className=" icon-dash-plus fs-19" /* onClick={() => handleOpenMarkAttendance(wednesdayRecord)}*/ ></i>
                                                </button>
                                                <div className="content-box">
                                                    <div className="d-flex align-items-center justify-content-between px-1-5 br-bottom-1 za_br_light pb-1-5">
                                                        <p className="heading fs-10 lh-10">Mark Attendance</p>
                                                        <div className="icon-Icon-metro-cross fs-8"></div>
                                                    </div>
                                                    <div className="pt-1-5 px-1-5">
                                                        <div className="d-flex align-items-center justify-content-between mb-2 selection-hover">
                                                            <p className={isEditAllowedPatAtt ? "text lh-18 ar-dot cursor-pointer" : "text lh-18 ar-dot cursor-pointer disabled"} onClick={() => handleSaveAttendnace(wednesdayRecord, true)}>Present</p>
                                                            <i className="icon-time-clock fs-12" onClick={() => handleOpenMarkAttendance(wednesdayRecord, null, null, true)}></i>
                                                        </div>
                                                        <div className="cursor-pointer selection-hover">
                                                            <p className={isEditAllowedPatAtt ? "text lh-18 ar-dot absent" : "text lh-18 ar-dot absent disabled"} onClick={() => handleOpenMarkAttendance(wednesdayRecord, null, null, false)}>Absent</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                            </div>
                        );
                    },
                    renderSummaryCell() {
                        return summaryRow?.Wed;
                    }
                }],

        },
        {
            // key: 'thu',
            name: "Thu",
            width: "50px",
            children: [
                {
                    key: 'Thursday',
                    resizeable: true,
                    name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                        iconName={'icon-location'} headerName={weeklyHeaders?.['Thu']?.date} sortIcon={false} type={'string'} colKey={'Day'} data={patientData} setData={setPatientData} />),

                    renderCell: ({ row }) => {

                        let thursdayRecord = {};
                        if (row?.Children && row?.Children?.length > 0) {
                            thursdayRecord = row?.Children?.filter((item) => item?.Day === 'Thursday')[0];
                        }

                        return (
                            <div className="align-items-center d-flex justify-content-center position-relative w-100 za-denied-status">
                                {(thursdayRecord?.Attendance === 'P' || thursdayRecord?.Attendance === 'A') ?
                                    <div className={(thursdayRecord?.IsScheduleCreated === '1' || thursdayRecord?.IsAllowedDays === '1') ? "days-scheduled" : ""}>
                                        <p className={`heading fs-12 za-table-status ${thursdayRecord?.Attendance === 'P' ? 'green-bg' : thursdayRecord?.Attendance === 'A' ? 'red-bg' : ''}  `}>{thursdayRecord?.Attendance}</p>
                                        <div className="app_tooltip right position-absolute cancel-attendance" onClick={() => handleClearAttendance(thursdayRecord)}>
                                            <i className="icon-Icon-metro-cross fs-8" ></i>
                                            <p class="tool_tip xsm_text text-light text-nowrap">Cancel Attendance</p>
                                        </div>
                                        {(thursdayRecord?.Attendance === 'P' && isNull(thursdayRecord?.CheckOut)) ? <div className="istrick fs-20 position-absolute">*</div> : <></>}
                                        <div className="xsm_text text-light tool_tip attendance_card position-absolute">
                                            <p className="heading fs-10 text-center pt-2">{thursdayRecord?.AttendanceDate}</p>
                                            <div className="br-bottom-1 br-light my-1"></div>
                                            {thursdayRecord?.Attendance === 'P' ?
                                                <>
                                                    <div className="d-flex justify-content-between px-2 pb-1-5">

                                                        <div className="d-flex align-items-center gap-1">
                                                            <div className="za-round"></div>
                                                            <p className="text fs-10 font-m">Check-In</p>
                                                        </div>

                                                        <p className="text fs-10">{thursdayRecord?.CheckIn}</p>


                                                    </div>
                                                    <div className="d-flex justify-content-between px-2 pb-1-5">

                                                        <div className="d-flex align-items-center gap-1">
                                                            <div className="za-round"></div>
                                                            <p className="text fs-10 font-m">Check-Out</p>
                                                        </div>

                                                        {!isNull(thursdayRecord?.CheckOut) ?

                                                            <p className="text fs-10">{thursdayRecord?.CheckOut}</p>
                                                            :
                                                            <div className="icon-plus d-flex justify-content-center align-items-center" onClick={() => handleOpenMarkAttendance(thursdayRecord)}>
                                                                <i className=" icon-dash-plus fs-19"></i>
                                                            </div>

                                                        }
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    {/* <div className="d-flex justify-content-between px-2 pb-1-5">

                                                        <div className="d-flex align-items-center gap-1">
                                                            <div className="za-round"></div>
                                                            <p className="text fs-10 font-m">Mark Present</p>
                                                        </div>

                                                        <div className="icon-plus d-flex justify-content-center align-items-center" onClick={() => handleOpenMarkAttendance(thursdayRecord)}>
                                                            <i className=" icon-dash-plus fs-19"></i>
                                                        </div>

                                                    </div> */}
                                                    {/* <div className="br-bottom-1 br-light my-1"></div> */}

                                                    <p class="fs-10 text px-1 multi-line-truncate text-wrap overflow-hidden">{thursdayRecord?.Reason} </p>

                                                </>
                                            }
                                        </div>
                                    </div>
                                    : thursdayRecord?.isBlocked === '1' ? <div className="days-block"></div> :
                                        <div className={(thursdayRecord?.IsScheduleCreated === '1' || thursdayRecord?.IsAllowedDays === '1') ? "days-scheduled" : ""}>
                                            <div className="ar_mark-attendance-hov position-relative">
                                                <button className="btn btn-plusicon d-flex justify-content-center align-items-center">
                                                    <i className=" icon-dash-plus fs-19" /* onClick={() => handleOpenMarkAttendance(thursdayRecord)}*/ ></i>
                                                </button>
                                                <div className="content-box">
                                                    <div className="d-flex align-items-center justify-content-between px-1-5 br-bottom-1 za_br_light pb-1-5">
                                                        <p className="heading fs-10 lh-10">Mark Attendance</p>
                                                        <div className="icon-Icon-metro-cross fs-8"></div>
                                                    </div>
                                                    <div className="pt-1-5 px-1-5">
                                                        <div className="d-flex align-items-center justify-content-between mb-2 selection-hover">
                                                            <p className={isEditAllowedPatAtt ? "text lh-18 ar-dot cursor-pointer" : "text lh-18 ar-dot cursor-pointer disabled"} onClick={() => handleSaveAttendnace(thursdayRecord, true)}>Present</p>
                                                            <i className="icon-time-clock fs-12" onClick={() => handleOpenMarkAttendance(thursdayRecord, null, null, true)}></i>
                                                        </div>
                                                        <div className="cursor-pointer selection-hover">
                                                            <p className={isEditAllowedPatAtt ? "text lh-18 ar-dot absent" : "text lh-18 ar-dot absent disabled"} onClick={() => handleOpenMarkAttendance(thursdayRecord, null, null, false)}>Absent</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                            </div>
                        );
                    },
                    renderSummaryCell() {
                        return summaryRow?.Thu;
                    }
                }
            ],

        },
        {
            // key: 'fri',
            name: "Fri",
            width: "50px",
            children: [
                {
                    key: 'Friday',
                    resizeable: true,
                    name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                        iconName={'icon-location'} headerName={weeklyHeaders?.['Fri']?.date} sortIcon={false} type={'string'} colKey={'Day'} data={patientData} setData={setPatientData} />),

                    renderCell: ({ row }) => {

                        let fridayRecord = {};
                        if (row?.Children && row?.Children?.length > 0) {
                            fridayRecord = row?.Children?.filter((item) => item?.Day === 'Friday')[0];
                        }

                        return (
                            <div className="align-items-center d-flex justify-content-center position-relative w-100 za-denied-status">
                                {(fridayRecord?.Attendance === 'P' || fridayRecord?.Attendance === 'A') ?
                                    <div className={(fridayRecord?.IsScheduleCreated === '1' || fridayRecord?.IsAllowedDays === '1') ? "days-scheduled" : ""}>
                                        <p className={`heading fs-12 za-table-status ${fridayRecord?.Attendance === 'P' ? 'green-bg' : fridayRecord?.Attendance === 'A' ? 'red-bg' : ''}  `}>{fridayRecord?.Attendance}</p>
                                        <div className="app_tooltip right position-absolute cancel-attendance" onClick={() => handleClearAttendance(fridayRecord)}>
                                            <i className="icon-Icon-metro-cross fs-8" ></i>
                                            <p class="tool_tip xsm_text text-light text-nowrap">Cancel Attendance</p>
                                        </div>
                                        {(fridayRecord?.Attendance === 'P' && isNull(fridayRecord?.CheckOut)) ? <div className="istrick fs-20 position-absolute">*</div> : <></>}
                                        <div className="xsm_text text-light tool_tip attendance_card position-absolute">
                                            <p className="heading fs-10 text-center pt-2">{fridayRecord?.AttendanceDate}</p>
                                            <div className="br-bottom-1 br-light my-1"></div>
                                            {fridayRecord?.Attendance === 'P' ?
                                                <>
                                                    <div className="d-flex justify-content-between px-2 pb-1-5">

                                                        <div className="d-flex align-items-center gap-1">
                                                            <div className="za-round"></div>
                                                            <p className="text fs-10 font-m">Check-In</p>
                                                        </div>

                                                        <p className="text fs-10">{fridayRecord?.CheckIn}</p>


                                                    </div>
                                                    <div className="d-flex justify-content-between px-2 pb-1-5">

                                                        <div className="d-flex align-items-center gap-1">
                                                            <div className="za-round"></div>
                                                            <p className="text fs-10 font-m">Check-Out</p>
                                                        </div>

                                                        {!isNull(fridayRecord?.CheckOut) ?

                                                            <p className="text fs-10">{fridayRecord?.CheckOut}</p>
                                                            :
                                                            <div className="icon-plus d-flex justify-content-center align-items-center" onClick={() => handleOpenMarkAttendance(fridayRecord)}>
                                                                <i className=" icon-dash-plus fs-19"></i>
                                                            </div>

                                                        }
                                                    </div>
                                                </> :
                                                <>
                                                    {/* <div className="d-flex justify-content-between px-2 pb-1-5">

                                                        <div className="d-flex align-items-center gap-1">
                                                            <div className="za-round"></div>
                                                            <p className="text fs-10 font-m">Mark Present</p>
                                                        </div>

                                                        <div className="icon-plus d-flex justify-content-center align-items-center" onClick={() => handleOpenMarkAttendance(fridayRecord)}>
                                                            <i className=" icon-dash-plus fs-19"></i>
                                                        </div>

                                                    </div> */}
                                                    <p class="fs-10 text px-1 multi-line-truncate text-wrap overflow-hidden">{fridayRecord?.Reason} </p>
                                                </>

                                            }
                                        </div>
                                    </div>
                                    : fridayRecord?.isBlocked === '1' ? <div className="days-block"></div> :
                                        <div className={(fridayRecord?.IsScheduleCreated === '1' || fridayRecord?.IsAllowedDays === '1') ? "days-scheduled" : ""}>
                                            <div className="ar_mark-attendance-hov position-relative">
                                                <button className="btn btn-plusicon d-flex justify-content-center align-items-center">
                                                    <i className=" icon-dash-plus fs-19" /* onClick={() => handleOpenMarkAttendance(fridayRecord)}*/ ></i>
                                                </button>
                                                <div className="content-box">
                                                    <div className="d-flex align-items-center justify-content-between px-1-5 br-bottom-1 za_br_light pb-1-5">
                                                        <p className="heading fs-10 lh-10">Mark Attendance</p>
                                                        <div className="icon-Icon-metro-cross fs-8"></div>
                                                    </div>
                                                    <div className="pt-1-5 px-1-5">
                                                        <div className="d-flex align-items-center justify-content-between mb-2 selection-hover">
                                                            <p className={isEditAllowedPatAtt ? "text lh-18 ar-dot cursor-pointer" : "text lh-18 ar-dot cursor-pointer disabled"} onClick={() => handleSaveAttendnace(fridayRecord, true)}>Present</p>
                                                            <i className="icon-time-clock fs-12" onClick={() => handleOpenMarkAttendance(fridayRecord, null, null, true)}></i>
                                                        </div>
                                                        <div className="cursor-pointer selection-hover">
                                                            <p className={isEditAllowedPatAtt ? "text lh-18 ar-dot absent" : "text lh-18 ar-dot absent disabled"} onClick={() => handleOpenMarkAttendance(fridayRecord, null, null, false)}>Absent</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                            </div>
                        );
                    },
                    renderSummaryCell() {
                        return summaryRow?.Fri;
                    }
                }],

        },
        {
            // key: 'sat',
            name: "Sat",
            width: "50px",
            children: [
                {
                    key: 'Day',
                    resizeable: true,
                    name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                        iconName={'icon-location'} headerName={weeklyHeaders?.['Sat']?.date} sortIcon={false} type={'string'} colKey={'Day'} data={patientData} setData={setPatientData} />),

                    renderCell: ({ row }) => {

                        let saturdayRecord = {};
                        if (row?.Children && row?.Children?.length > 0) {
                            saturdayRecord = row?.Children?.filter((item) => item?.Day === 'Saturday')[0];
                        }

                        return (
                            <div className="align-items-center d-flex justify-content-center position-relative w-100 za-denied-status">
                                {(saturdayRecord?.Attendance === 'P' || saturdayRecord?.Attendance === 'A') ?
                                    <div className={(saturdayRecord?.IsScheduleCreated === '1' || saturdayRecord?.IsAllowedDays === '1') ? "days-scheduled" : ""}>
                                        <p className={`heading fs-12 za-table-status ${saturdayRecord?.Attendance === 'P' ? 'green-bg' : saturdayRecord?.Attendance === 'A' ? 'red-bg' : ''}  `}>{saturdayRecord?.Attendance}</p>
                                        <div className="app_tooltip right position-absolute cancel-attendance" onClick={() => handleClearAttendance(saturdayRecord)}>
                                            <i className="icon-Icon-metro-cross fs-8" ></i>
                                            <p class="tool_tip xsm_text text-light text-nowrap">Cancel Attendance</p>
                                        </div>
                                        {(saturdayRecord?.Attendance === 'P' && isNull(saturdayRecord?.CheckOut)) ?
                                            <div className="istrick fs-20 position-absolute">*</div> : <></>}
                                        <div className="xsm_text text-light tool_tip attendance_card position-absolute">
                                            <p className="heading fs-10 text-center pt-2">{saturdayRecord?.AttendanceDate}</p>
                                            <div className="br-bottom-1 br-light my-1"></div>
                                            {saturdayRecord?.Attendance === 'P' ? <>
                                                <div className="d-flex justify-content-between px-2 pb-1-5">

                                                    <div className="d-flex align-items-center gap-1">
                                                        <div className="za-round"></div>
                                                        <p className="text fs-10 font-m">Check-In</p>
                                                    </div>

                                                    <p className="text fs-10">{saturdayRecord?.CheckIn}</p>


                                                </div>
                                                <div className="d-flex justify-content-between px-2 pb-1-5">

                                                    <div className="d-flex align-items-center gap-1">
                                                        <div className="za-round"></div>
                                                        <p className="text fs-10 font-m">Check-Out</p>
                                                    </div>

                                                    {!isNull(saturdayRecord?.CheckOut) ?

                                                        <p className="text fs-10">{saturdayRecord?.CheckOut}</p>
                                                        :
                                                        <div className="icon-plus d-flex justify-content-center align-items-center" onClick={() => handleOpenMarkAttendance(saturdayRecord)}>
                                                            <i className=" icon-dash-plus fs-19"></i>
                                                        </div>

                                                    }
                                                </div>
                                            </> :
                                                <>
                                                    {/* <div className="d-flex justify-content-between px-2 pb-1-5">

                                                        <div className="d-flex align-items-center gap-1">
                                                            <div className="za-round"></div>
                                                            <p className="text fs-10 font-m">Mark Present</p>
                                                        </div>

                                                        <div className="icon-plus d-flex justify-content-center align-items-center" onClick={() => handleOpenMarkAttendance(saturdayRecord)}>
                                                            <i className=" icon-dash-plus fs-19"></i>
                                                        </div>

                                                    </div> */}
                                                    <p class="fs-10 text px-1 multi-line-truncate text-wrap overflow-hidden">{saturdayRecord?.Reason} </p>
                                                </>}
                                        </div>
                                    </div>
                                    : saturdayRecord?.isBlocked === '1' ? <div className="days-block"></div> :
                                        <div className={(saturdayRecord?.IsScheduleCreated === '1' || saturdayRecord?.IsAllowedDays === '1') ? "days-scheduled" : ""}>
                                            <div className="ar_mark-attendance-hov position-relative">
                                                <button className="btn btn-plusicon d-flex justify-content-center align-items-center">
                                                    <i className=" icon-dash-plus fs-19" /* onClick={() => handleOpenMarkAttendance(saturdayRecord)}*/ ></i>
                                                </button>
                                                <div className="content-box">
                                                    <div className="d-flex align-items-center justify-content-between px-1-5 br-bottom-1 za_br_light pb-1-5">
                                                        <p className="heading fs-10 lh-10">Mark Attendance</p>
                                                        <div className="icon-Icon-metro-cross fs-8"></div>
                                                    </div>
                                                    <div className="pt-1-5 px-1-5">
                                                        <div className="d-flex align-items-center justify-content-between mb-2 selection-hover">
                                                            <p className={isEditAllowedPatAtt ? "text lh-18 ar-dot cursor-pointer" : "text lh-18 ar-dot cursor-pointer disabled"} onClick={() => handleSaveAttendnace(saturdayRecord, true)}>Present</p>
                                                            <i className="icon-time-clock fs-12" onClick={() => handleOpenMarkAttendance(saturdayRecord, null, null, true)}></i>
                                                        </div>
                                                        <div className="cursor-pointer selection-hover">
                                                            <p className={isEditAllowedPatAtt ? "text lh-18 ar-dot absent" : "text lh-18 ar-dot absent disabled"} onClick={() => handleOpenMarkAttendance(saturdayRecord, null, null, false)}>Absent</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                            </div>
                        );
                    },
                    renderSummaryCell() {
                        return summaryRow?.Sat;
                    }
                }
            ],

        },

        {
            // key: 'total',
            name: "Total",
            width: "50px",
            children: [
                {
                    key: 'Present',
                    resizeable: true,
                    name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                        iconName={'icon-location'} headerName={'P'} sortIcon={true} type={'string'} colKey={'Present'} data={patientData} setData={setPatientData} />),
                    renderCell: ({ row }) => {
                        return <div className="d-flex justify-content-center align-items-center w-100">{row?.Present}</div>;
                    },
                    renderSummaryCell() {

                        return <div className="d-flex justify-content-center align-items-center w-100">{summaryRow?.Present}</div>;
                    },

                },
                {
                    key: 'Absent',
                    resizeable: true,
                    name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                        iconName={'icon-location'} headerName={'A'} sortIcon={true} type={'string'} colKey={'Absent'} data={patientData} setData={setPatientData} />),

                    renderCell: ({ row }) => {
                        return <div className="d-flex justify-content-center align-items-center w-100">{row?.Absent}</div>;
                    },

                    renderSummaryCell() {
                        return <div className="d-flex justify-content-center align-items-center w-100">{summaryRow?.Absent}</div>;
                    },
                },
                {
                    key: 'action',
                    name: 'Action',
                    renderCell: ({ row }) => {
                        return (
                            <button className="position-relative border-0 bg-transparent no-width rounded mt-1">
                                <i className="icon-notes" onClick={(e) => handleActiveNotesSideBar(e, row)}>
                                    {row.NotesCount === "" ? (
                                        <></>
                                    ) : (
                                        <span className="ar_count xsm_heading text-white fw-700 end_-3">
                                            {row.NotesCount}
                                        </span>
                                    )}
                                </i>
                            </button>
                        );
                    }
                },

            ],
        },
    ];

    const bottomSummaryRows = patientData?.length > 0 ? [summaryRow] : [];
    const [Columns, setColumns] = useState(columns)
    ///////////////// Open Authorization Popup ///////////////

    const handleOpenAuthorization = (data) => {
        setIsOpenAuthorization(true);
        setAuthorizationID(data?.PatientAuthorizationID);
        setPatientInsuranceID(data?.PatientInsuranceID);
        setPatientID(data?.PatientID);
    }

    const CloseInsurance = () => {

        setIsOpenAuthorization(false);

    }

    const DeleteInsurance = () => {
        setIsOpenAuthorization(false);
        // handleAuthorizationDetails();
    }

    let PopupScreen = "";
    if (IsOpenAuthorization) {
        PopupScreen = <AddNewAuthorization IsOpenAuthorization={IsOpenAuthorization} onClose={CloseInsurance} onDeleteInsurance={DeleteInsurance} AuthorizationID={AuthorizationID} PatientInsuranceID={PatientInsuranceID} InsuranceListModal={InsuranceListModal} PatientID={patientID} />
    }

    /////// handle save attendnace /////

    const handleSaveAttendnace = (record, isAttendance) => {
        if (isEditAllowedPatAtt) {
            setIsLoading(true);
            let saveModal = {
                ID: 0,
                TableName: enumUtil.enumAPITableName.PATIENTATTENDANCE,
                data: {
                    Attendance: isAttendance + "",
                    AttendanceDate: record?.DATE,
                    CheckIn: isAttendance ? record?.DefaultStartTime ? record?.DefaultStartTime : "10:00 AM" : "",
                    CheckOut: isAttendance ? record?.DefaulEndTime ? record?.DefaulEndTime : "12:00 PM" : "",
                    PatientAuthorizationID: record?.PatientAuthorizationID,
                    PatientID: record?.PatientID,
                    PatientInsuranceID: record?.PatientInsuranceID,
                },
            }
            ServerRequestProtected(API_URL_PATIENT + '/SaveSingleRecord', 'post', saveModal)
                .then((response) => {
                    setIsLoading(false);
                    LoadData(searchParam);
                    NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success);
                }).catch((error) => {
                    NotificationHandler(error.message, enumUtil.enumtoaster.error);
                    setIsLoading(false);

                })
        }
    }

    ///////// handle clear attendance ////

    const handleClearAttendance = (record, isAttendance) => {

        // handleSaveAttendnace(record, "");
        setIsLoading(true);
        let saveModal = {
            "TableName": enumUtil.enumAPITableName.PATIENTATTENDANCE,
            "ID": record?.PatientAttendanceID || 0,
        }

        ServerRequestProtected(API_URL + '/DeleteSingleRecord', 'post', saveModal)
            .then((response) => {

                setIsLoading(false);
                LoadData(searchParam);
                // NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success);

            }).catch((error) => {

                NotificationHandler(error.message, enumUtil.enumtoaster.error);
                setIsLoading(false);

            })

    }
    ///////////////// Open Mark Attendnace Popup ///////////////

    const handleOpenMarkAttendance = (record, patientID, type, attendance) => {

        if (type === "Multiple") {
            console.log("selectedPatientIDs", selectedPatientIDs, "Duplicate Patients", PatientDuplicateRecord)

            if (isNull(selectedPatientIDs)) {
                NotificationHandler("Please Select Patient(s)", enumUtil?.enumtoaster?.warning);
                return
            }
            else if (Array.isArray(PatientDuplicateRecord) && PatientDuplicateRecord?.length > 0) {
                let duplicatePatientNames = PatientDuplicateRecord?.map(item => item.PatientName);
                let firstRecord = duplicatePatientNames[0];
                NotificationHandler(`Patient [${firstRecord}] found with multiple authorizations, please mark one authorization at a time`, enumUtil?.enumtoaster?.warning);
                return
            }
            else {

                let dateInRange = checkDateRange(searchParam?.DateFrom, searchParam?.DateTo);

                if (!dateInRange) {

                    return
                }
            }
        }

        setAttendance(attendance);
        setAttendnaceType(type);
        setAttendaceRecord(record);
        setAttendanceRecordID(record?.PatientAttendanceID);
        // setSelectedPatientIDs(patientID);
        setPatientID(patientID);
        setIsOpenMarkAttendance(true);

    }

    const onClose = () => {
        setIsOpenMarkAttendance(false);
    }

    const onCloseSave = () => {

        LoadData(searchParam);
        setIsOpenMarkAttendance(false);
        setPatientID(null);
        setSelectedPatientIDs("");
        setSelectedRows(new Set());
        // setReloadPatientGrid(!reloadPatientGrid);

    }

    let MarkAttendance = "";
    if (IsOpenMarkAttendane) {
        MarkAttendance = <MarkNewAttendance openPopup={IsOpenMarkAttendane} onClose={onClose} onCloseSave={onCloseSave} ID={AttendanceRecordID} AttendanceData={AttendanceRecord} PatientID={AttendanceType === "Multiple" ? selectedPatientIDs : patientID} AttendanceType={AttendanceType} searchDateParam={searchDateParam} AttendanceProp={Attendance} />
    }

    const handleActiveNotesSideBar = (e, row) => {
        setShowBillingNote(!showBillingNote);
        setSelectedRow(row);
        e.stopPropagation();
    };

    const closeNotesSideBar = () => {
        setShowBillingNote(false);
    };

    const patientHeader = () => {
        return <p style={{ color: '#434343', fontFamily: 'Poppins', fontWeight: '600', margin: '0', fontSize: '15px' }}>Patient Search</p>;
    };

    const StatusOption = [
        { value: "Active", display: "Active" },
        { value: "Hold", display: "Hold" },
        { value: "Discharged", display: "Discharged" },
    ]

    const closeDropdown = () => {
        setFilterShow(false)

    };

    const handleFilterOpen = (e) => {
        setFilterShow(!filterShow)
        e.stopPropagation();

    }

    const handleSelectedData = (selectedData, name, type) => {

        if (type === 'client' && !isNull(selectedData)) {
            if (name === "InsuranceID" && !isNull(selectedData)) {
                setSearchParam({ ...searchParam, InsuranceID: selectedData.value + "" });
                setSelectedInsurance(selectedData.display);
            }
            if (name === "CoordinatorID" && !isNull(selectedData)) {
                setSearchParam({ ...searchParam, CoordinatorID: selectedData.value + "" });
                setselectCoordinator(selectedData.display);
            }
            if (name === "ProviderID" && !isNull(selectedData)) {
                // setProviderID(selectedData.value + "")
                setSearchParam({ ...searchParam, ProviderID: selectedData.value + "" });
                setselectprovider(selectedData.display)
            }
            if (name === "LocationID" && !isNull(selectedData)) {
                // setProviderID(selectedData.value + "")
                setSearchParam({ ...searchParam, LocationID: selectedData.value + "" });
                setselectLocation(selectedData.display)
            }
            if (name === "RefProviderID" && !isNull(selectedData)) {
                // setRefProviderID(selectedData.value + "")
            }
        } else if (type === 'server' && !isNull(selectedData)) {

        } else {

        }

        return selectedData
    }

    const handleMUltiSelectedData = (selectedDataArray, type, name) => {

        let modal = { ...searchParam };
        if (type === 'server' && selectedDataArray.length > 0) {
            const displayValues = selectedDataArray.map(data => data.display);
            const valueValues = selectedDataArray.map(data => data.value);
            modal[name] = displayValues.join(', ');
            // PatientSaveUpdateModal[name] = valueValues.join(', ');
        } else if (type === 'client' && selectedDataArray.length > 0) {
            const displayValues = selectedDataArray.map(data => data.display);
            const valueValues = selectedDataArray.map(data => data.value);
            let joinvlues = valueValues.join(', ');
            modal[name] = valueValues.join(', ');
            if (name === "InsuranceID" && !isNull(selectedDataArray)) {
                setSelectedInsurance(joinvlues);
            }
        }
        else {

            modal[name] = '';
            // PatientSaveUpdateModal[name] = '';
        }
        setSearchParam(modal);
        // setPatientSaveUpdateModal(PatientSaveUpdateModal);
        return selectedDataArray;
    }

    const handleAddNewShift = (e) => {
        setIsOpenShift(true);
    }

    const handleCloseStatus = () => {
        setIsOpenShift(false)
        setReloadSuperSearchShift(!reloadSuperSearchShift)
    }

    let ShiftPopup = ""
    if (IsOpenShift) {
        ShiftPopup = <AddNewShift isOpenMarketer={IsOpenShift} onClose={handleCloseStatus} onDeleteCoordinator={handleCloseStatus} />
    }

    const handleChange = (e) => {
        let { name, value } = e.target
        // setSearchParam({ ...searchParam, SearchLetter: null, name: value || null })
        if (name === 'InsuranceID') {
            setSelectedInsurance(value)
        } else if (name === 'CoordinatorID') {
            setselectCoordinator(value)
        }
        else if (name === 'ProviderID') {
            setselectprovider(value)
        }
        else if (name === 'LocationID') {
            setselectLocation(value)
        }
    }

    const isValidDate = (date) => {
        return moment(date, 'MM/DD/YYYY', true).isValid();
    }

    // const GenerateHeaders = (dateFrom, dateTo) => {

    //     if (isValidDate(dateFrom, dateTo)) {
    //         let startDate = moment(dateFrom, "MM/DD/YYYY").toDate()
    //         const weekStart = startOfWeek(startDate, { weekStartsOn: 0 }); // Sunday as the start of the week
    //         const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday',];

    //         const weekDates = weekDays.reduce((acc, day, index) => {
    //             acc[day] = format(addDays(weekStart, index), 'dd/MM');
    //             return acc;
    //         }, {});

    //         setWeeklyHeaders(weekDates);

    //         return weekDates;
    //     }
    // }

    function reorderColumns(columns, headers) {
        // Find indices for the start and end of the day columns
        // const dayKeys = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

        // const startIdx = columns.findIndex(col => dayKeys.includes(col.key));
        // const endIdx = columns.findLastIndex(col => dayKeys.includes(col.key));

        // Fixed columns before the days
        const fixedBefore = columns.slice(0, 2);

        // Day columns extracted for reordering
        const dayColumns = columns.slice(2, 9);

        // Fixed columns after the days
        const fixedAfter = columns.slice(9);

        // Reorder the day columns based on the headers array
        const reorderedDayColumns = headers.map(header => {
            return dayColumns.find(col => col.name === header.dayName);
        }).filter(Boolean);

        // Maintain original structure by combining parts
        return [...fixedBefore, ...reorderedDayColumns, ...fixedAfter];
    }

    function generateHeaders(startDate, endDate) {
        if (!startDate || !endDate) return [];

        // Create an array of dates from startDate to endDate
        const dateRange = eachDayOfInterval({ start: new Date(startDate), end: new Date(endDate) });

        // Map each date to the desired header format
        const headers = dateRange.map(date => ({
            dayName: format(date, 'EEE'), // Short day name (e.g., Fri)
            date: format(date, 'dd/MM'),  // Date format (e.g., 07/02)
        }));

        const headersObject = dateRange.reduce((acc, date) => {
            const dayName = format(date, 'EEE'); // Short day name (e.g., Fri)
            const formattedDate = format(date, 'MM/dd'); // Date format (e.g., 07/02)
            acc[dayName] = { day: dayName, date: formattedDate };
            return acc;
        }, {});

        setHeadersArray(headers);
        setWeeklyHeaders(headersObject);

        return headersObject;
    }

    const getDateDifference = (start, end) => {
        if (!start || !end) return 0;

        const diffTime = Math.abs(new Date(end) - new Date(start)); // Difference in milliseconds
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // Convert ms to days
    };

    // Function to check if the range is greater or less than 7 days
    const checkDateRange = (startDate, endDate) => {

        if (!isValidDate(startDate)) {
            return true
        }

        const diffInDays = getDateDifference(startDate, endDate);

        if (diffInDays > 7) {
            NotificationHandler("The date range is greater than 7 days", enumUtil.enumtoaster.warning)
            return false
        } else if (diffInDays < 7) {
            NotificationHandler("The date range is less than 7 days", enumUtil.enumtoaster.warning)
            return false
        } else {
            return true;
        }
    };

    useEffect(() => {
        let columnsReorder = reorderColumns(columns, headers);
        setColumns(() => Array.isArray(columnsReorder) ? columnsReorder : columns);
    }, [weeklyHeaders])

    useEffect(() => {

        if (isValidDate(searchDateParam.DateTo)) {

            setSearchParam({ ...searchParam, DateFrom: searchDateParam?.DateFrom, DateTo: searchDateParam?.DateTo })

        }
    }, [searchDateParam])

    useEffect(() => {
        setReloadSuperSearchShift(!reloadSuperSearchShift);
    }, [DropDowns])

    useEffect(() => {
        const val = searchValue.toLowerCase();

        const filteredData =
            val.length > 0
                ? DefaultPatientData.filter(item =>
                    [item.PatientName,
                    item.MedicaidNo,
                    item.AuthorizationNumber,
                    item.InsuranceName]
                        .some(item => String(item).toLowerCase().includes(val))
                )
                : [...DefaultPatientData];

        setPatientData(filteredData);
        handleGridHeader({ defaultData: filteredData });

    }, [searchValue, DefaultPatientData]);   // 🔑 


    return (
        <>
            {popup}
            {MarkAttendance}
            {PopupScreen}
            {ShiftPopup}
            {/* <div className='p-2 pt-1 pb-0'>
                {openTab ? <ContentReceiver data={openTab} setOpenTab={setOpenTab} /> : null}
                <div className='alphabetic-filter m-auto'>
                    <button className='refresh active'>
                        <i className="icon-Icon-awesome-sync-alt" onClick={() => handleSearchByAlphabet(null)}></i>
                    </button>
                    <button>
                        <i className='icon-angle-left' onClick={handlePreviousAlphabet}></i>
                    </button>
                    <div className='alphabetics'>
                        <span value={searchParam} >{searchParam}</span>
                        {Alphbets.map((type) => {
                            return (
                                <span className={type.value === searchParam.SearchLetter ? 'active' : ''} onClick={() => handleSearchByAlphabet(type.value)} key={type.value}>{type.value}</span>
                            )
                        })}
                    </div>
                    <button>
                        <i className='icon-right-direction' onClick={handleNextAlphabet}></i>
                    </button>
                </div>
            </div> */}
            <div className="container-fluid py-2">
                <div className="row row-half row-gap-5 flex-grow-1 align-items-end ">
                    <div className="col-lg-3">
                        <div className="input">
                            <label className="hs-patient-label">Name</label>
                            <input type="text" className="form-control rounded"
                                placeholder="Search by name, ssn, Insured id or Medicaid…"
                                value={searchParam.SearchCeriteria}
                                onChange={e => setSearchParam({ ...searchParam, SearchCeriteria: e.target.value })}
                                onKeyDown={SearchOnEnter}
                            />
                        </div>
                    </div>
                    <div className="col-md-3 multipleSearch-rounded">
                        <div className='input simple_select position-relative'>
                            <label className="hs-patient-label">Insurance</label>

                            <SuperSearchMultipleClient
                                key={reloadSuperSearch}
                                id="InsuranceID"
                                name="InsuranceID"
                                selectedOptionsDisplay='Insurance'
                                initialSelectedValues={[]}
                                options={DropdownData.Insurance?.filter(item => !['-1', -1].includes(item.value))}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                onSelect={handleMUltiSelectedData}
                                sup_btn="sup_btn-Inp"
                                sup_inp="superSearchVisitInp"
                            />

                        </div>
                    </div>
                    {isHomeCareCheck === "true" && (
                        <div className="col-md-3 multipleSearch-rounded">
                            <div className="input race">

                                <label className="hs-patient-label">Status</label>

                                <SuperSearchMultipleClient
                                    key={reloadSuperSearch}
                                    id="Status"
                                    name="Status"
                                    selectedOptionsDisplay='Status'
                                    initialSelectedValues={[]}
                                    searchParam={searchParam}
                                    setSearchParam={setSearchParam}
                                    options={AuthStatusDD?.filter(item => !['-1', -1].includes(item.value))}
                                    onSelect={handleMUltiSelectedData}
                                    sup_btn="sup_btn-Inp"
                                    sup_inp="superSearchVisitInp"
                                />
                            </div>
                        </div>
                    )}
                    <div className="col-md-3 multipleSearch-rounded">
                        <div className="input filters-field">
                            <label className="hs-patient-label">Date</label>
                            <CalendaRangeInput key={reloadCalendarReload} searchParam={searchDateParam} setSearchParam={setSearchDateParam} options={['Date']} type={'weekCheck'} defaultDates={currentWeek} label={false} />
                        </div>
                    </div>
                    <div className="col-md-3 multipleSearch-rounded">
                        <div className="input race">

                            <div className=" d-flex  align-items-center justify-content-between">
                                <label className="hs-patient-label">Shift</label>
                                <div className='app_tooltip right top-2' onClick={(e) => handleAddNewShift(e)}>
                                    <button className="btn-icon-circle btn-xs hk-plusWrapper__Btn add_status-btn"><i className="icon-dash-plus"></i></button>
                                    <p class="tool_tip xsm_text text-light">Add Shift</p>
                                </div>
                            </div>

                            <SuperSearchMultipleClient
                                key={reloadSuperSearchShift}
                                id="Shift"
                                name="Shift"
                                selectedOptionsDisplay='Shift'
                                initialSelectedValues={[]}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                options={PatientShiftsDD?.filter(item => !['-1', -1].includes(item.value))}
                                onSelect={handleMUltiSelectedData}
                                sup_btn="sup_btn-Inp"
                                sup_inp="superSearchVisitInp"
                            />
                        </div>
                    </div>
                    {/* <div className="col-lg-3">
                            <div className="input">
                                <label className="hs-patient-label">Insurance</label>
                                <select className="form-control fc-xs rounded" id='InsuranceID' name='InsuranceID' value={searchParam.InsuranceID}
                                    onChange={(e) => setSearchParam({ ...searchParam, SearchLetter: null, InsuranceID: e.target.value || null })}>
                                    {DropdownData.Insurance?.map((e, index) => (
                                        <option value={e.value} key={index}>
                                            {e.display}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div> */}
                    <div className="col-lg-4 d-flex align-items-end">

                        <div className='btns-group-flex'>
                            <button className={isEditAllowed ? 'btn btn-orange btn-xs no-width rounded' : 'btn btn-orange btn-xs no-width rounded disabled'} onClick={SearchByParam}>Search</button>
                            <div className='line-border'></div>
                            <button className='btn btn-outline btn-xs no-width rounded' onClick={() => clearFilter()}>Clear</button>
                            <div className='line-border'></div>
                            <button className={isEditAllowedPatAtt ? 'btn btn-validate btn-xs no-width rounded' : 'btn btn-validate btn-xs no-width rounded disabled'}
                                onClick={() => handleOpenMarkAttendance(SelectedRecordsArray, selectedPatientIDs, "Multiple")}>Mark Attendance</button>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2 col-md-5 justify-content-end">

                        <div className="claims_info payment-icon position-relative input w-45">
                            <input
                                className="form-control rounded"
                                type="text"
                                value={searchValue}
                                onChange={(e) => setSearchValue(e.target.value)}
                                placeholder='Search records'
                            />
                            <i className='icon-Clip-path-group fs-13'></i>
                        </div>

                        <div className="za-denied-status position-relative">
                            <span class="icon-question fs-19"><span class="path1"></span><span class="path2"></span></span>

                            <div className='xsm_text text-light tool_tip za-status pateint_tooltip'>
                                <div className="d-flex align-items-center gap-1 mb-1">
                                    <div className="za_circles">
                                        <div className="green_circle"></div>
                                    </div>
                                    <p className="text fs-11"> <span className="font-m me-1">Scheduled Days:</span>Marked in green</p>
                                </div>
                                <div className="d-flex align-items-center gap-1 mb-1">
                                    <div className="za_circles">
                                        <div className="gray_circle"></div>
                                    </div>
                                    <p className="text fs-11"> <span className="font-m me-1">Non-Scheduled Days:</span>White, allowing user to mark attendance</p>
                                </div>
                                <div className="d-flex align-items-center gap-1 mb-1">
                                    <div className="za_circles">
                                        <div className="gray_circle"></div>
                                    </div>
                                    <p className="text fs-11"> <span className="font-m me-1">Days Outside Auth Period:</span>Greyed out or disabled</p>
                                </div>
                            </div>
                        </div>
                        <div className="no-search-margin">
                            <SearchHeader
                                AddNew={AddNewPatient}
                                Filter={handleFilterOpen}
                                FilterClass={IsFilterApplied}
                                searchButton={searchButton}
                                Key={21}
                                tableName={enumUtil.enumAPITableName.PATIENTATTENDANCE}
                                Name={'Patient Attendance'}
                                searchParam={{ ...searchParam, IsExcelExport: "1" }}
                                PerPage={PerPage}
                                PageNo={PageNo}
                                TotalPages={TotalPages}
                                isEmpty={patientData.length > 0}

                            />
                        </div>
                    </div>

                </div>
                {
                    <CustomUseRef
                        onClose={closeNotesSideBar}
                        IsActivePtPayments={showBillingNote}
                    >
                        {
                            <div className="ar_claims-TabHeader__notes">
                                <PatientAttendanceNotes
                                    BillingDocumentTypeID={selectRow?.PatientID}
                                    row={selectRow}
                                    onClose={closeNotesSideBar}
                                    isNotes={showBillingNote}
                                />
                            </div>
                        }
                    </CustomUseRef>
                }
            </div>
            {isLoading ? <Loader /> : null}
            <div className="Patient_attendance">

                <ReactDataGrid
                    enableVirtualization={false}
                    columns={Columns}
                    rows={patientData}
                    headerRowHeight={25}
                    rowHeight={25}
                    rowClass={rowClass}
                    className={`fill-grid DataGrid-Table hk-exp-table overflow-auto custom_checkboxes_gird ${(patientData).length < 60 ? 'ar-grid-footer' : ''}`}
                    style={{ userSelect: 'text', height: '465px' }}
                    bottomSummaryRows={bottomSummaryRows}
                    rowKeyGetter={row => row.id}
                    selectedRows={selectedRows}
                    onSelectedRowsChange={onRowSelection}
                    defaultColumnOptions={{ resizable: true }}
                />
                <Pagination
                    selectedRows={selectedRows}
                    Counts={totalCounts}
                    PerPage={PerPage}
                    PageNo={PageNo}
                    TotalPages={TotalPages}
                    handlePageClick={handlePageClick}
                    PreviousPage={PreviousPage}
                    handleFingByCreteria={handleFingByCreteria}
                    NextPage={NextPage}
                    handleSelectData={handleSelectData}
                />
                {/* <div className={`sidebar-filters ${filterShow && 'active'}`}>
                    <div className="sidebar-filters__heading">
                        <span>Filters</span>
                        <button className="btn btn-transparent" onClick={clearFilter}>
                            <i className="bi bi-x"></i>
                        </button>
                    </div>
                    <hr />
                    <div className="sidebar-filters__body h-100">
                        <div className="input filters-field multipleSearch-rounded">
                            <label>Provider</label>
                            <SuperSearchMultipleClient
                                key={reloadSuperSearch}
                                id="ProviderID"
                                name="ProviderID"
                                selectedOptionsDisplay='Provider'
                                initialSelectedValues={[]}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                options={DropDowns.Provider?.filter(item => !['-1', -1].includes(item.value))}
                                onSelect={handleMUltiSelectedData}
                                sup_btn="sup_btn-Inp"
                                sup_inp="superSearchVisitInp"
                            />
                        </div>
                        <hr />
                        <div className="input filters-field multipleSearch-rounded">
                            <label>Location</label>
                            <SuperSearchMultipleClient
                                key={reloadSuperSearch}
                                id="LocationID"
                                name="LocationID"
                                selectedOptionsDisplay='Location'
                                initialSelectedValues={[]}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                options={DropDowns.Location?.filter(item => !['-1', -1].includes(item.value))}
                                onSelect={handleMUltiSelectedData}
                                sup_btn="sup_btn-Inp"
                                sup_inp="superSearchVisitInp"
                            />
                        </div>
                        {isHomeCareCheck === "true" && (
                            <div className="input filters-field">
                                <div className='input simple_select position-relative'>
                                    <label>Coordinator</label>
                                    <SuperSearchList
                                        type="client"
                                        id='CoordinatorID'
                                        name='CoordinatorID'
                                        searchValue={selectCoordinator}
                                        data={DropDowns.CoOrdinator}
                                        onChange={(e) => handleChange(e)}
                                        getSelectedData={handleSelectedData}
                                        is={is}
                                        icon={'Simple'}
                                        sup_btn='sup_simple_btn'
                                        sup_inp='sup_simple_Inp'
                                        className="form-control rounded"
                                    />
                                </div>
                            </div>
                        )}
                        <div className="input filters-field">
                            <CalendaRangeInput searchParam={searchParam} setSearchParam={setSearchParam} options={['Entry Date']} />
                        </div>
                    </div>

                    <div className="sidebar-filters__footer">
                        <button className="btn btn-orange" onClick={handleApply}>Apply</button>
                    </div>
                </div> */}
            </div>

            {/* Patient Search Modal */}
            {/* <Modal show={false} onHide={false} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg master_list_modal">
                <Modal.Body>
                    <SearchHeader />
                    <ModalHeader HeaderName={patientHeader} DeletePopup={""} isClosed={() => { }} key={631} Name={'SwitchPractice'} />
                    <div className='container-fluid  br-clr'>
                        <div className="row">
                            <div className="col-12 mb-2 ">
                                <div className="input">
                                    <div className='input-group hk-input-search'>
                                        <input type="text" className='form-control fc-xs'
                                            placeholder='Search by name, DOB, account #, phone #'
                                        // onChange={e => setSearchParam(e.target.value)}
                                        // onKeyDown={SearchOnEnter} 
                                        />
                                        <span className="input-group-text" id="basic-addon2">
                                            <i className="bi bi-search"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="opened-block">
                                    <p className="heading">Recently Opened</p>
                                    <DataGrid
                                        columns={columnsAll}
                                        headerRowHeight={25}
                                        rowHeight={25}
                                        rows={rowsAll}
                                        className="all_audit fill-grid DataGrid-Table bg-light-blue sr-table popper-t-table"
                                    />
                                </div>
                            </div>
                            <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                                <button className="btn btn-orange btn-xs no-width rounded mb-0 master_list_add">Search</button>
                                <button className="btn btn-orange btn-xs no-width rounded mb-0 master_list_close">Cancel</button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal> */}
        </>
    )
}

function mapStateToPropss(state) {
    return {
        OpenDynamicTab: state.Open_Patient_Tab ? state.Open_Patient_Tab : [],
        Settings: state.SettingsReducer
    };
}

const action = {
    TabActionPatient,
};

export default connect(mapStateToPropss, action)(PatientAttendance);

